/**
 * 模拟 UUID
 * @returns {string}
 */
const KUuid = () => {
  return Math.random()
    .toString(36)
    .slice(4)
}

export default KUuid
